import React, { Fragment } from 'react';

const ListLevel = ({ title, value, subList }) => {
  return (
    <Fragment>
      <div className='list-level'>
        <div className='list-level__header'>
          <h3 className='list-level__title'>{title}</h3>
          <span className='list-level__value'>{value}</span>
        </div>

        {subList && (
          <div className='list-level__items'>
            {subList.map((a, index) => (
              <div key={index} className='list-level__item'>
                <span className='list-level__item-label'>{a.label}</span>
                <span className={`list-level__item-value ${a.warning ? 'list-level__item-value--warning' : ''}`}>
                  {a.value}
                </span>
              </div>
            ))}
          </div>
        )}
      </div>
    </Fragment>
  )
}

export default ListLevel;
